import React from "react";

type LinkBlockProps = {
  lien: string;
  logo: React.ReactNode;
  description: string;
};

const LinkBlock: React.FC<LinkBlockProps> = ({ lien, logo, description }) => {
  return (
    <a
      href={lien}
      target="_blank"
      className="flex transform flex-row items-center justify-center gap-x-8 gap-y-8 rounded border-whiteAccent  bg-darkAccent p-8 text-whiteAccent transition duration-300 hover:scale-105 md:flex-col"
      rel="noreferrer noopener"
    >
      {logo}
      <p className="text-sm font-bold md:text-xl">{description}</p>
    </a>
  );
};

export default LinkBlock;
